var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDivineshield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.875 20.844c-61.545.405-123.647 9.54-187.47 27.812L59.938 50.5l-.28 6.72c-6.405 147.46 49.12 346.625 192.28 429.28l4.688 2.688 4.656-2.688c139.03-80.27 201.88-281.764 195.376-429.28l-.125-5.907-6.624-2.657c-63.63-18.215-126.57-27.65-190.062-27.812-1.984-.005-3.984-.013-5.97 0zm.344 18.625c1.86-.013 3.73-.006 5.593 0 59.47.15 118.43 8.782 178.28 25.343 3.956 139.034-57.428 327.223-181.468 402.625-128.09-77.646-182.55-263.02-178.438-402.594C138.233 48.228 196.493 39.838 254.22 39.47zM258 56.03l-28.438 126.72-45.312-25.313 26.97 48.25-92.5 26.157 91.655 25.937-26.688 47.72 45.625-25.5 28.657 127.688 28.655-127.625 45.875 25.656-26.72-47.814 91.845-26-92.75-26.25 27.063-48.406-45.5 25.438L258 56.03z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivineshield);
export default __webpack_public_path__ + "static/media/divineshield.7b2e11d06fb6d4e0989fff5ba99e0d81.svg";
export { ForwardRef as ReactComponent };